/**
 * SalesManago event types
 * Based on https://docs.salesmanago.com/frontend-sdk/#external-event-types
 */
export enum SmEventType {
    CREATE_CONTACT = 'CREATE_CONTACT',
    PURCHASE = 'PURCHASE',
    CART = 'CART',
    TRANSACTION = 'TRANSACTION',
    CANCELLATION = 'CANCELLATION',
    RETURN = 'RETURN',
    VISIT = 'VISIT',
    PHONE_CALL = 'PHONE_CALL',
    OTHER = 'OTHER',
    RESERVATION = 'RESERVATION',
    CANCELLED = 'CANCELLED',
    ACTIVATION = 'ACTIVATION',
    MEETING = 'MEETING',
    OFFER = 'OFFER',
    DOWNLOAD = 'DOWNLOAD',
    LOGIN = 'LOGIN',
    SURVEY = 'SURVEY',
}